import { CMSConnector } from 'umg-cms-js-sdk/src'
import mock from './__mock__'

let connector: CMSConnector

if (process.env.VUE_APP_MOCK !== 'true') {
  connector = new CMSConnector()
} else {
  // @ts-ignore
  connector = mock
}

export default connector
